// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/app.scss
// module id = ./resources/assets/sass/app.scss
// module chunks = 2